import { render, staticRenderFns } from "./InviteesList.vue?vue&type=template&id=51e2fbdb&"
import script from "./InviteesList.vue?vue&type=script&lang=js&"
export * from "./InviteesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51e2fbdb')) {
      api.createRecord('51e2fbdb', component.options)
    } else {
      api.reload('51e2fbdb', component.options)
    }
    module.hot.accept("./InviteesList.vue?vue&type=template&id=51e2fbdb&", function () {
      api.rerender('51e2fbdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/Invitees/InviteesList.vue"
export default component.exports